import styled from 'styled-components';

export const DescriptionStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 35%;
  background: #fff;
  padding: 2rem;
  text-align: center;

  .title {
    margin-bottom: 1rem;
    font-size: ${props => props.theme.font.h4};
    font-weight: 500;
  }

  .description {
    color: ${props => props.theme.color.gray};
  }
`;
